import http from 'hub-http/clients/apiClient';
import { BASE_URI_PROGRESS } from '../../constants/ApiConstants';
import { registerMutation, useMutation } from 'academy-common-lib/utils/DataFetchingClient';
import { create } from 'zustand';
import { useCallback } from 'react';
import produce from 'immer';
import { useAchievementByTrackId } from '../achievement/achievementQueries';
import { GET_USER_PROGRESS_QUERY } from '../../../__generated__/chirp/com/hubspot/userprogress/bff/rpc/UserProgressBFFChirpService.dfc.new';
const UPDATE_AWARD_PERMISSION = registerMutation({
  fieldName: 'updateAwardPermission',
  fetcher({
    awardCode,
    shouldBePublic
  }) {
    return http.put(`${BASE_URI_PROGRESS}/granted-certifications/permission`, {
      data: {
        awardCode,
        isPublic: shouldBePublic
      }
    });
  }
});
const useAwardPermissionUpdating = create(set => ({
  isUpdatingPermission: {},
  setIsUpdatingPermission: (awardCode, isUpdatingPermission) => set(produce(state => {
    state.isUpdatingPermission[awardCode] = isUpdatingPermission;
  }))
}));
export const useUpdateAwardPermission = (awardCode, shouldBePublic, trackId) => {
  const [mutate, {
    loading: updateAwardPermissionLoading,
    called: updateAwardPermissionCalled,
    error: updateAwardPermissionError
  }] = useMutation(UPDATE_AWARD_PERMISSION, {
    variables: {
      awardCode,
      shouldBePublic
    },
    refetchQueries: [{
      query: GET_USER_PROGRESS_QUERY,
      variables: {
        requestedProgress: [{
          id: trackId,
          type: 'TRACK'
        }]
      }
    }]
  });
  const {
    isUpdatingPermission,
    setIsUpdatingPermission
  } = useAwardPermissionUpdating();
  const updateAwardPermission = useCallback(() => {
    setIsUpdatingPermission(awardCode, true);
    return mutate().then(data => {
      setIsUpdatingPermission(awardCode, false);
      return data;
    });
  }, [awardCode, mutate, setIsUpdatingPermission]);
  return [updateAwardPermission, {
    updateAwardPermissionLoading,
    updateAwardPermissionGlobalLoading: isUpdatingPermission[awardCode],
    updateAwardPermissionCalled,
    updateAwardPermissionError
  }];
};
export const useAwardByTrackId = trackId => {
  const {
    achievement
  } = useAchievementByTrackId(trackId.toString());
  if (!achievement) return null;
  const achievementTrack = achievement.tracks.find(track => track.id === trackId.toString());
  if (!achievementTrack) return null;
  return achievementTrack.award;
};